import axios from 'axios';
import url from './Url';

class User extends url {
    constructor() { super() }

    getUser = (axiosConfig) => {
        return axios.get(`${this.url()}/user`, axiosConfig)
            .then(response => {
                return response;
            })
            .catch(err => {

                if (err.response.status) {
                    //localStorage.removeItem('token')
                    //window.location.href = '/';
                }
                return err
            });
    }

    download = (id, nome) => {
        axios.get(`${this.url()}/download/${id}`, { responseType: "blob" })
            .then((response) => {

                const blob = new Blob([response.data], { type: response.headers["content-type"] });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${nome}`;
                //a.download = `${id}_${nome}`;
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
            })
            .catch((err) => console.error("Erro ao baixar o arquivo:", err));
    };
}

export default User;
